module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/754baa103c2ac348fe5d6ecca59bea5a.png";